import { ToastsAction, ToastsActionsNames } from "./actions";
import { IToastDetails } from "./interfaces";

export interface IToastsState {
  items: {
    [key: string]: IToastDetails;
  };
}

export const initialState = {
  items: {},
};

const toastReducer = (state: IToastsState = initialState, action: ToastsAction): IToastsState => {
  switch (action.type) {
    case ToastsActionsNames.SHOW: {
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { autoHideDelayTime: _, ...toast } = action.payload;
      return {
        ...state,
        items: {
          ...state.items,
          [toast.id]: {
            ...toast,
          },
        },
      };
    }

    case ToastsActionsNames.REMOVE: {
      const { id } = action.payload;
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: removedToast, ...items } = state.items;
      return {
        ...state,
        items,
      };
    }

    case ToastsActionsNames.REMOVE_ALL: {
      return {
        ...state,
        items: {},
      };
    }

    default:
      return state;
  }
};

export default toastReducer;
